import { render, staticRenderFns } from "./gameswitch.vue?vue&type=template&id=09db9f90&"
import script from "./gameswitch.vue?vue&type=script&lang=js&"
export * from "./gameswitch.vue?vue&type=script&lang=js&"
import style0 from "./gameswitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports